import React from 'react';

function GifloaderMini() {

    return (
        <>
            <div className='text-center gifloader'>
                <img src={require("../../images/tce-loader.gif")} alt="" />
            </div>
        </>
    )
}

export default GifloaderMini;